import React from 'react';
import {OrbitComponentWithState} from "../../base-components/orbit-component-with-state/orbit-component-with-state";
import {Link} from "../../raw-components/link/link";
import {UserInfo} from '../../user-info/user-info.component';
import {observer} from "mobx-react";
import {CyClass} from '../../../../common/cy-classes';
import {ProfilePictureBox} from "./boxes/profile-picture.box";
import {ProfileUserNameBox} from "./boxes/profile-user-name.box";

export interface ProfilePictureProps {
  marketingDl: string,
}

export interface ProfilePictureState {
  avatarState: string,
}

const avatarState = {
  regular: 'regular',
  hover: 'hover',
  pressed: 'pressed',
};

@observer
export class ProfilePicture extends OrbitComponentWithState<ProfilePictureProps, ProfilePictureState> {
  state = {
    avatarState: 'regular',
  };

  render() {
    const imageSize = this.services.mediaQuery.xlAndBelow ? "68" : "91";

    return (
      <ProfilePictureBox>
        <Link className={`${CyClass('cy-profile-picture')}`}
              onClick={() => this._openUserMenu()}>
          <img src={this._getAvatarUrl()}
               alt="888casino player"
               onMouseEnter={() => this._updateAvatarState(avatarState.hover)}
               onMouseLeave={() => this._updateAvatarState(avatarState.regular)}
               onMouseDown={() => this._updateAvatarState(avatarState.pressed)}
               onMouseUp={() => this._updateAvatarState(avatarState.regular)}
               width={imageSize}
               height={imageSize}
          />
        </Link>
        {this._renderUserName()}
      </ProfilePictureBox>
    )
  }

  private _getAvatarUrl() {
    const config = this.services.configuration.data.generalSettings.avatarUrl;
    return config.sideMenu[this.state.avatarState] || config.sideMenu[avatarState.regular]
  }

  private _updateAvatarState(newState: string) {
    this.setState({avatarState: newState || avatarState.regular});
  }

  private _renderUserName() {
    if (!this.services.user.isAuthorized)
      return null;

    return <ProfileUserNameBox>
      <UserInfo selectedUserInfo="userName" />
    </ProfileUserNameBox>;
  }

  private _openUserMenu() {
    if (!this.services.user.isAuthorized) {
      this.services.analytics.sendAnalytics('Navigation', 'NavBar', 'Avatar_Login');
      this.services.user.openLogin({}, {dl: this.props.marketingDl});
      return;
    }

    if (!this.services.userMenu.isOpen) {
      this.services.userMenu.openMenu();
      return;
    }

    if (this.services.userMenu.isRewardsInfo) {
      this.services.userMenu.closeMenu();
      this.services.userMenu.openMenu();
    } else {
      this.services.userMenu.closeMenu();
    }
  }
}
